module.exports = __webpack_public_path__ + "img/blue_087.6f17e198.png";